exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".referral_program {\n  padding: 10px;\n}\n.referral_program .box-left {\n  border: 1px solid #cad6de;\n  margin: 10px 0;\n}\n.referral_program .box-right {\n  border-left: none;\n}\n.referral_program .view {\n  color: #2e6da4;\n  cursor: pointer;\n}\n.referral_program .validate-popup .modal-inner {\n  max-width: 400px;\n}", ""]);

// exports
